export class EmailDomain {
    public idEmailDomain: number;
    public domainName: string;
    public datetimeInclusion: Date;
    public idHealthUnit: number;
}